import { cosemApi } from '@services/providers/cosem';
import { OrganizationCode, OrganizationCodeToCreate, OrganizationCodeToUpdate } from './organization-codes.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';

const organizationCodesApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getPaginatedOrganizationCodes: build.mutation<
            ApiPaginationResponse<OrganizationCode>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/organization-codes/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<OrganizationCode>) => response
        }),
        getArchivedPaginatedOrganizationCodes: build.mutation<
            ApiPaginationResponse<OrganizationCode>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/organization-codes/archived/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<OrganizationCode>) => response
        }),
        updateOrganizationCode: build.mutation<ApiResponse<OrganizationCode>, OrganizationCodeToUpdate>({
            query: (organizationCode: OrganizationCodeToUpdate) => {
                return {
                    url: `/member/organization-codes/${organizationCode.id}`,
                    method: 'PUT',
                    body: organizationCode
                };
            },
            transformResponse: (response: ApiResponse<OrganizationCode>) => response
        }),
        createOrganizationCode: build.mutation<ApiResponse<OrganizationCode>, OrganizationCodeToCreate>({
            query: (organizationCode: OrganizationCodeToCreate) => {
                return {
                    url: `/member/organization-codes`,
                    method: 'POST',
                    body: organizationCode
                };
            },
            transformResponse: (response: ApiResponse<OrganizationCode>) => response
        }),
        deleteOrganizationCode: build.mutation<ApiResponse<OrganizationCode>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/member/organization-codes/${id}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<OrganizationCode>) => response
        }),
        toggleArchiveOrganizationCode: build.mutation<ApiResponse<OrganizationCode>, { id: string|number, archived: boolean }>({
            query: ({ id, archived }) => {
                return { 
                    url: `/member/organization-codes/${id}/archive`, 
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<OrganizationCode>) => response
        }),
    })
});

export const {
    useGetPaginatedOrganizationCodesMutation,
    useGetArchivedPaginatedOrganizationCodesMutation,
    useUpdateOrganizationCodeMutation,
    useCreateOrganizationCodeMutation,
    useDeleteOrganizationCodeMutation,
    useToggleArchiveOrganizationCodeMutation
} = organizationCodesApi;
